import React, { useMemo, useState } from 'react';

import { useAssignPreconfig } from '../../../hooks/preconfig-hooks';

import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';
import PatientsPreconfigCheckList from '../PatientsPreconfigCheckList/PatientsPreconfigCheckList';
import ErrorSpinnerWrapper from '../../UI/ErrorSpinnerWrapper.tsx/ErrorSpinnerWrapper';

import { Preconfiguration } from '../../../interfaces/Preconfigurations';

interface Props {
    assign: boolean
    preconfig: Preconfiguration
    setShow: React.Dispatch<React.SetStateAction<boolean>>
    onAssigned?: () => void
}

const AssignPreconfiguration: React.FC<Props> = ({
    assign,
    preconfig,
    setShow,
    onAssigned
}) => {
    const [casesChecked, setCasesChecked] = useState<number[]>([]);

    const {
        isLoading,
        error,
        assignedCaseIds,
        currentPreconfigCaseIds,
        assign: assignFn,
        unAssign
    } = useAssignPreconfig(preconfig.id, () => {
        onAssigned?.();
        setShow(false);
    });

    const assignedSet = useMemo(
        () => new Set(assignedCaseIds),
        [assignedCaseIds]
    );

    const currentPreconfigSet = useMemo(
        () => new Set(currentPreconfigCaseIds),
        [currentPreconfigCaseIds]
    );

    const handleLinkCases = (checked: boolean, caseId: number) => {
        if (assign && assignedSet.has(caseId) && !currentPreconfigSet.has(caseId)) return;

        setCasesChecked((oldIDs) =>
            checked
                ? oldIDs.includes(caseId)
                    ? oldIDs
                    : [...oldIDs, caseId]
                : oldIDs.filter((id) => id !== caseId)
        );
    };

    const onConfirm = () => {
        if (assign) assignFn(casesChecked);
        else unAssign(casesChecked);
    };

    const blockedCaseIds = useMemo(
        () => assign
            ? assignedCaseIds.filter((caseId) => !currentPreconfigSet.has(caseId))
            : [],
        [assign, assignedCaseIds, currentPreconfigSet]
    );

    return (
        <>
            <ErrorSpinnerWrapper loading={isLoading} error={error}>
                <PatientsPreconfigCheckList
                    caseIdsLinked={casesChecked}
                    caseIdsBlocked={blockedCaseIds}
                    caseIdsHidden={assign ? currentPreconfigCaseIds : []}
                    caseIdsToShow={assign ? undefined : currentPreconfigCaseIds}
                    handleClickCheckbox={handleLinkCases}
                    searchbar
                />
            </ErrorSpinnerWrapper>
            <CancelConfirmButtons
                onCancel={() => setShow(false)}
                onConfirm={onConfirm}
            />
        </>
    );
};

export default AssignPreconfiguration;